module.exports = __webpack_public_path__ + "static/LIT-full-logo(gold)-077157f6ebd807fb17e7e8ead732285e.svg";